import { useEffect, useState } from 'react';
import notificationService from '../services/notificationService';

export function useNotifications() {
  const [permission, setPermission] = useState(notificationService.permission);
  const [isSupported] = useState(notificationService.isSupported());

  useEffect(() => {
    const checkPermission = async () => {
      if (isSupported && permission === 'default') {
        await notificationService.requestPermission();
        setPermission(notificationService.permission);
      }
    };

    checkPermission();
  }, [isSupported, permission]);

  const requestPermission = async () => {
    if (isSupported) {
      await notificationService.requestPermission();
      setPermission(notificationService.permission);
    }
  };

  return {
    isSupported,
    permission,
    hasPermission: permission === 'granted',
    requestPermission,
    showNotification: notificationService.showNotification.bind(notificationService),
    playSound: notificationService.playNotificationSound.bind(notificationService)
  };
}